import SelectRowCell from '@/backgrid/SelectRowCell';
import PageableCollection from '@/backbone/PageableCollection';
import StringCell from '@/backgrid/StringCell';
import GridView from '@/views/GridView';

const UserSearchGridView = GridView.extend({
  options: {
    pageSize: 50
  },

  initialize() {
    this.options.columns = [
      {
        name: 'selected',
        label: '',
        ariaLabel: 'Select',
        cell: SelectRowCell.SelectRowCell,
        headerCell: SelectRowCell.SelectAllHeaderCell,
        width: 3,
        editable: true,
        sortable: false
      },
      {
        name: 'name',
        label: 'Name',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'email',
        label: 'Email',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      }
    ];
    this.collection = new PageableCollection([], {
      pageSize: this.options.pageSize
    });
    this.options.emptyText = 'No Users Found';
    GridView.prototype.initialize?.apply(this, this.options);
  }
});

export default UserSearchGridView;
